import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/app/layouts/default.vue").then(m => m.default || m)),
  top: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/app/layouts/top.vue").then(m => m.default || m))
}